module.exports = __webpack_public_path__ + "media/images/new-ui-images/next-arrow-hover-8e0859953ee5b6c873be632260757ec5.svg";